import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import { isNotEmpty, isNotNil } from '@k2/common/helpers';
import {CollectionType, Field, Fields} from '@k2/common/k2-forms-state/types';
import {cloneDeep} from "lodash";
import {Observable, of} from "rxjs";
import {KeyValue} from "@angular/common";
import {cloneControlAsUntyped} from "@k2/common/k2-forms/fields";

@Component({
    selector: 'collection-type-field-control',
    templateUrl: 'collection-type-field-control.component.html',
    styleUrls: ['collection-type-field-control.component.scss'],
    standalone: false
})
export class CollectionTypeFieldControlComponent implements OnChanges, OnInit {
  @Input() field: Field;
  values: CollectionType[] = [];
  columnsFields: Observable<Fields>;
  collectionPrototype: CollectionType;
  @Output() onChange = new EventEmitter<ChangeCollectionItem>();

  ngOnChanges(): void {
  }

  ngOnInit(): void {
    this.field.control.setValue([])
    if (!this.field.prototype) {
      throw Error('CollectionTypeFieldControlComponent require have prototype in field definition');
    }
    this.values = this.field.fieldCollection;
    this.collectionPrototype = this.createPrototypeFields(this.field.prototype)
    this.collectionPrototype.collectionId = null
    this.columnsFields = this.collectionPrototype.fields;
    this.values.map(((list) => {
      this.createFieldsFromSpec(list);
    }))
    if (!this.values.length) {
      this.addEmptyValue()
    }
  }

  createPrototypeFields(collection: CollectionType): CollectionType{
    let copyFields = [];
    collection.fields.forEach((fields => {
      copyFields = Object.values(fields).map((field => {
        let f = cloneDeep(field)
        f.control = cloneControlAsUntyped(field.control);
        f.control.setValue(null)
        f.form = field.form
        f.validators = [];
        f.errors = null; // use null/undefined to match FieldErrors type instead of []
        return f;
      }));
    }));
    var fieldsObj: Fields = {};
    copyFields.forEach((field) => {
      fieldsObj[field.name] = field;
    });
    return {
      collectionId: collection.collectionId,
      fields: of(fieldsObj)
    };
  }

  createFieldsFromSpec (list: CollectionType) {
    var collectionFields = {}
    list.fields.forEach((fields) => {
      Object.values(fields).forEach((f) => {
        collectionFields[f.attributes.originName] = f.attributes.originVal;
        f.control.valueChanges.subscribe((item: any) => {
          f.form.updateValueAndValidity()
          collectionFields[f.attributes.originName] = item;
          this.onChange.emit({
            collectionId: list.collectionId,
            fieldName: f.attributes.originName,
            value: item
          })
        });
      });
    });

    collectionFields['id'] = list.collectionId;
    var currentData = this.field.control.value || [];
    currentData.push(collectionFields);
    this.field.control.setValue(currentData);

    return list.fields
  }
  onRadioSwitchChange(collectionId: number) {
    for (const collection of this.values) {
      collection.fields.forEach((fields) => {
        Object.values(fields).forEach((field) => {
          if (field.attributes.display_type === 'radioSwitch') {
            if (collectionId == collection.collectionId) {
              this.setFieldValueInCollection(collection.collectionId, field.attributes.originName, true);
            } else {
              this.setFieldValueInCollection(collection.collectionId, field.attributes.originName, false);
            }
          }
        })
      })
    }
  }

  setFieldValueInCollection(collectionId: number, name: string, value: any) {
    var currentData = this.field.control.value || [];
    for (const data of currentData) {
      if (data['id'] == collectionId) {
        data[name] = value;
        this.field.control.setValue(currentData);
        return;
      }

    }
  }

  propagateValueChange() {

  }

  addEmptyValue = () => {
    var defaultVal = this.defaultValue;
    defaultVal.fields.forEach((fields) => {
      Object.values(fields).forEach((field) => {
        field.form.addControl(this.field.name+'_'+defaultVal.collectionId+'_'+field.name, field.control);
      })
    })

    this.values.push(defaultVal);
  };

  removeValue = (idx: number) => {
    let collection = this.values[idx]
    collection.fields.forEach((fields) => {
      Object.values(fields).forEach((field) => {
        field.form.removeControl(this.field.name+'_'+collection.collectionId+'_'+field.name);
      })
    });
    let valDeleted = this.values.splice(idx, 1);
    var currentData: any[] = this.field.control.value
    let deleted = currentData.splice(idx, 1);
    if (deleted.length > 0 && valDeleted[0]) {
      valDeleted[0].fields.forEach((fields) => {
        Object.values(fields).forEach((field) => {
          if (field.attributes.display_type === 'radioSwitch' && field.control.value) {
            this.resetRadioSwitchFieldOnFirstElement();
          }
        })
      })
    }

    this.field.control.setValue(currentData);
    this.propagateValueChange();
  };

  resetRadioSwitchFieldOnFirstElement() {
    for (const collection of this.values) {
      collection.fields.forEach((fields) => {

        Object.values(fields).forEach((field) => {
          if (field.attributes.display_type === 'radioSwitch') {
            if (this.values[0].collectionId == collection.collectionId) {
              field.control.setValue(this.values[0].collectionId)
              this.setFieldValueInCollection(collection.collectionId, field.attributes.originName, true);
            } else {
              field.control.setValue(null)
              this.setFieldValueInCollection(collection.collectionId, field.attributes.originName, false);
            }
          }
        })
      })
    }
  }

  get canRemove(): boolean {
    return this.values.length > 1;
  }

  private get defaultValue(): CollectionType {
    var randomId = Math.floor(Math.random() * 10e6);
    var clonedCollection = this.createPrototypeFields(this.collectionPrototype)
    return {
      collectionId: randomId,
      fields: this.createFieldsFromSpec(clonedCollection)
    }

  }

  keyAscOrder = (a: KeyValue<string,Field>, b: KeyValue<string,Field>): number => {
    return a.value.attributes.orderPriority < b.value.attributes.orderPriority ? -1 : (b.value.attributes.orderPriority < a.value.attributes.orderPriority ? 1 : 0);
  }

  classListColumn(value: Field) {
    if (value.attributes.display_type === 'textarea') {
      return 'col-4 align-items-center'
    }
    if (value.attributes.display_type === 'radioSwitch') {
      return 'col-1 align-items-center'
    }
    if (value.attributes.display_type === 'tel') {
      return 'col-2 align-items-center'
    }

    return 'col-3 align-items-center'

  }
}

type Value = any[];

function isValidValue(value: Value): boolean {
  return value.every(v => isNotNil(v) && isNotEmpty(v));
}

export type ChangeCollectionItem = {
    collectionId: number,
    fieldName: string,
    value: any
}
